/* product.js — bundle builder + sélection de variante (Chérie Charms)
   Le format (1/2/3 charms) = variante native qui porte le prix.
   Le drop de chaque charm = line item property (properties[charm N]). */
(function () {
  'use strict';

  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var priceEl = document.querySelector('[data-product-price]');
  var stickyPriceEl = document.querySelector('[data-sticky-price]');
  var mainPriceEl = document.querySelector('[data-main-price]');
  var stickyBundleEl = document.querySelector('[data-sticky-bundle]');
  var stickySubmit = document.querySelector('[data-sticky-submit]');
  var variantInput = form.querySelector('[data-variant-id]');
  var bundleInputs = form.querySelectorAll('[data-bundle-option]');
  var charmRows = form.querySelectorAll('[data-charm-row]');

  var cfg = window.CherieProduct || { variants: [] };

  function formatMoney(cents) {
    if (window.CherieFormatMoney) return window.CherieFormatMoney(cents);
    var fmt = (window.CherieCart && window.CherieCart.moneyFormat) || '${{amount}}';
    var amount = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, token) {
      var thousands = ',', decimalSep = '.';
      if (token.indexOf('comma_separator') !== -1) { thousands = '.'; decimalSep = ','; }
      else if (token.indexOf('space_separator') !== -1) { thousands = ' '; decimalSep = ','; }
      else if (token.indexOf('apostrophe_separator') !== -1) { thousands = "'"; decimalSep = '.'; }
      var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
      if (decimals === 2 && cents % 100 === 0) decimals = 0; // sans zéros de fin (ex. 19 $ au lieu de 19,00 $)
      var parts = amount.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
    });
  }

  /* Affiche N sélecteurs de drop selon le format choisi, met à jour le prix
     et l'id de variante caché soumis au panier. */
  function applyBundle(count, variantId) {
    charmRows.forEach(function (row, i) {
      var active = i < count;
      row.hidden = !active;
      var select = row.querySelector('select');
      if (select) {
        // désactive les champs cachés pour qu'ils ne soient pas soumis
        select.disabled = !active;
        select.required = active;
      }
    });

    if (variantId && variantInput) variantInput.value = variantId;

    var variant = cfg.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (variant && priceEl) {
      priceEl.innerHTML = formatMoney(variant.price) +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
    }
    if (variant && stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
    if (variant && mainPriceEl) mainPriceEl.textContent = formatMoney(variant.price);

    // met à jour la pilule de bundle du sticky (ex. « 2 charms »)
    if (stickyBundleEl) {
      var checkedOpt = form.querySelector('[data-bundle-option]:checked')
        || form.querySelector('[data-bundle-option][value="' + variantId + '"]');
      var card = checkedOpt && checkedOpt.closest('.bundle-option');
      var lblEl = card && card.querySelector('.bundle-option__label');
      if (lblEl) stickyBundleEl.textContent = lblEl.textContent.trim();
    }

    // synchronise l'URL (?variant=) avec la variante sélectionnée (corrige aussi un ?variant= périmé)
    if (variantId && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== String(variantId)) {
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      } catch (e) {}
    }
  }

  if (stickySubmit) {
    stickySubmit.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    });
  }

  // pilule de bundle du sticky -> défile vers le sélecteur de charms
  var bundleJump = document.querySelector('[data-sticky-bundle-jump]');
  if (bundleJump) {
    bundleJump.addEventListener('click', function () {
      var bundle = document.querySelector('[data-bundle]');
      if (!bundle) return;
      bundle.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var opt = bundle.querySelector('[data-bundle-option]:checked') || bundle.querySelector('[data-bundle-option]');
      if (opt) { try { opt.focus({ preventScroll: true }); } catch (e) { opt.focus(); } }
    });
  }

  bundleInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var count = parseInt(input.getAttribute('data-charm-count'), 10) || 1;
      applyBundle(count, input.value);
    });
  });

  // état initial : option cochée par défaut
  var checked = form.querySelector('[data-bundle-option]:checked');
  if (checked) {
    applyBundle(parseInt(checked.getAttribute('data-charm-count'), 10) || 1, checked.value);
  }
})();
